/* eslint-disable no-dupe-keys */
export default {
  charging_card: {
    name: '充电卡',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '充电卡名',
      charging_card_definition: '充电卡',
      charge_stations: '适用电站',
      user: '用户',
      serial_number: '充电卡号',
      amount: '卡初始金额',
      used_amount: '已消费金额',
      remaining_amount: '卡余额',
      status: '状态',
      remaining_effective_days: '剩下生效天数',
      begin_time: '生效时间',
      end_time: '失效时间',
      created_at: '领取时间',
      updated_at: '更新时间',
      last_charging_time: '最后消费时间',
      charging_card_definition_name: '充电卡名称'
    },
    // Enum的属性
    statuses: {
      // enabled: '已启用',
      // disabled: '已停用',
      pending: '待生效',
      active: '生效中',
      // expired: '已过期',
      invalid: '已失效'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_serial_number: '查询卡号'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      consumption_records: '消费记录'
    },
    // 标题
    titles: {
      using_rules: '使用规则'
    },
    tips: {
      expired_tips: '还剩下 {0} 天过期'
    },
    list_tabs: {
      pending: '待生效',
      active: '生效中',
      disable: '已停用',
      invalid: '已失效'
    },
    balance_formula: {
      balance: '余额',
      total_amount: '总金额',
      consume_amount: '消费金额',
      inactive_amount: '已失效'
    }
  }
}
